import { notification } from 'antd'
import apiClient from 'services/axios'
import { getLoggedInUserInfo } from 'utils'

export const getAllAttendance = async (params) => {
  const empId = getLoggedInUserInfo()?.empId
  try {
    return await apiClient.get(`employee/allAttendance-record?empId=${empId}`, {
      params,
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.error || 'Something went wrong',
      })
    }
  }
  return null
}
export const getEmpAttendance = async (year) => {
  const empId = getLoggedInUserInfo()?.empId
  try {
    return await apiClient.get(`employee/attendance-record?empId=${empId}&year=${year}`)
  } catch (error) {
    if (error?.response?.status) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
export const getSingleMonthAttendance = async (userId, month, year) => {
  try {
    return await apiClient.get(
      `attendance/getAttendanceByMonth?userId=${userId}&month=${month}&year=${year}`,
    )
  } catch (error) {
    if (error?.response?.status) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getEmpAttendanceReport = async ({ skip, limit, userId, month, year }) => {
  try {
    return await apiClient.get(`attendance/attendanceReport/${userId}`, {
      params: {
        skip,
        limit,
        month,
        year,
      },
    })
  } catch (error) {
    if (error?.response?.status) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getHour = ({ userId, year }) => {
  return apiClient.get(`employee/totalhour/${userId}`, {
    params: {
      userId,
      year,
    },
  })
}
